export default {"src":"/bnb/_next/static/media/immunefi.91f481b7.svg","height":20,"width":21};